import PaymentInfo from "./PaymentInfo";

export default PaymentInfo;
